/* eslint-disable react-hooks/exhaustive-deps */
import { Spinner } from 'components/shared/loader/Spinner';
import { CONFIGURE_VIEW, areas } from 'constants/constants';
import { memo, useEffect, useRef } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCardsData,
  getDefultViewCard,
} from 'store/home/home-my-view-actions';
import DefaultMessage from '../message/DefaultMessage';
import Tile from './Tile';
import classes from './Tiles.module.scss';
import { usePromiseTracker } from 'react-promise-tracker';

const TileContainer = memo(({ page }) => {
  const dispatch = useDispatch();
  const { unixId } = useSelector((state) => state.Auth.userClaimObject);
  const { roleId } = useSelector((state) => state.Auth.userClaimObject);
  const cards = useSelector((state) => state?.HomeMyView?.cards);
  const impactedCards = useSelector(
    (state) => state?.HomeMyView?.impactedCards
  );
  const defaultCards = useSelector((state) => state?.HomeMyView?.defaultCards);
  const selectedView = useSelector((state) => state?.HomeMyView?.selectedView);
  const hasCards = useRef(true);
  const hasDefaultCard = useRef(true);
  const shouldLoadDefault = useRef(true);
  const userRestrictedRole = useSelector(
    (state) => state?.Auth?.userRestriction
  );
  const userRestrictedEcosystemt = useSelector(
    (state) => state?.Auth?.userRestrictedEcosystemt
  );
  const restrictedProductSquad = useSelector(
    (state) => state?.Auth?.restrictedProductSquad
  );
  const defaultCustomerType = useSelector(
    (state) => state?.CustomerView?.defaultCustomerType
  );
  const { promiseInProgress } = usePromiseTracker({ area: areas.home });

  const items = page === CONFIGURE_VIEW.myDefault ? defaultCards : cards;

  useEffect(() => {
    if (page === CONFIGURE_VIEW.myView) {
      dispatch(
        getCardsData(
          unixId,
          roleId,
          selectedView?.Id,
          userRestrictedRole,
          userRestrictedEcosystemt,
          restrictedProductSquad,
          0,
          20,
          defaultCustomerType
        )
      );

      setTimeout(() => {
        hasCards.current = false;
      }, 100);
    }
  }, [selectedView?.Id]);

  useEffect(() => {
    if (page === CONFIGURE_VIEW.myDefault) {
      dispatch(
        getDefultViewCard(
          unixId,
          selectedView?.Id,
          userRestrictedRole,
          userRestrictedEcosystemt,
          restrictedProductSquad,
          page === CONFIGURE_VIEW.myDefault ? roleId : '',
          defaultCustomerType
        )
      );
      shouldLoadDefault.current = false;

      setTimeout(() => {
        hasDefaultCard.current = false;
      }, 100);
    }
  }, [selectedView.Id]);

  const ListElement = ({ item: card, area }) => {
    return (
      <Col
        sm={12}
        md={6}
        xxl={4}>
        <Tile
          card={card}
          impactedCards={impactedCards}
          key={card.cardId}
          page={page}
          area={area}
        />
      </Col>
    );
  };

  return (
    <>
      {((page === CONFIGURE_VIEW.myView && cards?.length > 0) ||
        (page === CONFIGURE_VIEW.myDefault && defaultCards?.length > 0)) && (
        <div className={classes['tile-container-drag-drop-container']}>
          <Row className='list-manager g-3'>
            {items?.map((item, index) => (
              <ListElement
                key={index}
                item={item}
                area={item.cardId}
              />
            ))}
          </Row>
        </div>
      )}

      {promiseInProgress && <Spinner area={areas.home} />}

      {cards?.length === 0 &&
        !promiseInProgress &&
        page !== CONFIGURE_VIEW.myDefault && (
          <Fade>
            <DefaultMessage page={page} />
          </Fade>
        )}
    </>
  );
});

export default TileContainer;
